import { AppModule, AppRoute } from './core';

import accountModule from './modules/account';
import adminModule from './modules/admin';
import coursesModule from './modules/courses';
import scanResultsModule from './modules/scan-results';
import simulatorModule from './modules/simulator';
import studentsModule from './modules/students';
import maintenanceModule from './modules/maintenance';
import startModule from './modules/dashboard';
import errorModule from './modules/error';

const modules: Array<AppModule> = [
  accountModule,
  adminModule,
  coursesModule,
  scanResultsModule,
  simulatorModule,
  studentsModule,
  maintenanceModule,
  startModule,
  errorModule,
];

let appRoutes: Array<AppRoute> = [];

modules.forEach((module) => {
  if (module.routes) {
    appRoutes = appRoutes.concat(module.routes);
  }
});

export const routes = appRoutes;

export default modules;
